module.exports = __webpack_public_path__ + "img/wbs1.3ac4dffd.png";